import { EventSource, EventType, Frequency, InviteStatus, ModuleKey, TaskGroup } from '../types/family';
import { ExceptionType, ExcuseKey, PollKind, RewardStatus, SchoolKind } from '../types/shared';

export const groupOrder: TaskGroup[] = ['rutina', 'sola', 'zivali', 'hisa', 'vecer'];

export const groupLabels: Record<TaskGroup, string> = {
  rutina: 'Rutina',
  sola: 'Šola',
  zivali: 'Živali',
  hisa: 'Hiša',
  vecer: 'Večer',
};

export const eventTypeLabels: Record<EventType, string> = {
  sola: 'Šolski dogodek (pohod, izlet, dan dejavnosti)',
  sluzba: 'Služba',
  'pouk-instrumenta': 'Pouk instrumenta',
  solfeggio: 'Solfeggio / teorija',
  orkester: 'Orkester',
  zbor: 'Zbor',
  sport: 'Šport',
  nastop: 'Nastop',
  tekma: 'Tekma',
  roditeljski: 'Roditeljski sestanek',
  pregled: 'Pregled',
  druzinsko: 'Družinsko',
  osebno: 'Osebno',
};

export const sourceLabels: Record<EventSource, string> = {
  app: 'App',
  'google-druzinski': 'Google: Družinski',
  'google-viva': 'Google: VIVA',
};

export const exceptionTypeLabels: Record<ExceptionType, string> = {
  bolezen: 'Bolezen',
  odsotnost: 'Upravičena odsotnost',
  pocitnice: 'Počitnice',
  'poseben-vecer': 'Poseben večer',
};

export const defaultExcuses: Record<ExceptionType, ExcuseKey[]> = {
  bolezen: ['branje', 'sport', 'instrument', 'ucenje', 'hisa'],
  odsotnost: ['branje', 'sport', 'instrument', 'ucenje', 'hisa', 'vecer'],
  pocitnice: ['ucenje'],
  'poseben-vecer': ['vecer'],
};

export const excuseLabels: Record<ExcuseKey, string> = {
  branje: 'Branje',
  sport: 'Šport',
  instrument: 'Vadba instrumenta',
  ucenje: 'Učenje in domače naloge',
  hisa: 'Hišna opravila',
  vecer: 'Večerna rutina',
  soba: 'Sobotna soba',
  zivali: 'Oskrba živali',
};

export const schoolKindLabels: Record<SchoolKind, string> = {
  test: 'Test / kontrolna',
  sprasevanje: 'Spraševanje',
  domaca: 'Domača naloga',
  todo: 'Osebni TODO',
};

export const pollKindLabels: Record<PollKind, string> = {
  film: 'Film',
  igra: 'Družabna igra',
  'skupni-cas': 'Skupni čas',
  igranje: 'Termin igranja',
};

export const rewardStatusLabels: Record<RewardStatus, string> = {
  caka: 'Čaka na starša',
  odobreno: 'Odobreno',
  koristeno: 'Koriščeno',
  zavrnjeno: 'Zavrnjeno',
};

export const inviteLabels: Record<InviteStatus, string> = {
  brez: 'Brez vabila',
  poslano: 'Vabilo poslano',
  sprejeto: 'Sprejeto',
  poteklo: 'Poteklo',
  preklicano: 'Preklicano',
};

export const moduleLabels: Record<ModuleKey, { label: string; hint: string }> = {
  hisnaOpravila: { label: 'Hišna opravila', hint: 'Tedenske kategorije, soba, posteljnina' },
  osebnaRutina: { label: 'Osebna rutina', hint: 'Branje, šport in osebni cilji' },
  sola: { label: 'Šola', hint: 'Testi, domače naloge, učni bloki, TODO' },
  zivali: { label: 'Živali', hint: 'Hranjenje (z vodo), sprehodi, stranišča, kletke' },
  glasba: { label: 'Glasba / instrumenti', hint: 'Domača vadba z izjemo dneva pouka' },
  vecerniRezim: { label: 'Večerni režim', hint: 'Ure, odlaganje naprav' },
  nagrade: { label: 'Nagrade in žepnina', hint: 'Kačing, goodies, katalog' },
  skupniSeznami: { label: 'Skupni seznami', hint: 'Nakupi, glasovanja, želje' },
};

export function frequencyLabel(f?: Frequency): string {
  if (!f) return 'Enkratno';
  switch (f.kind) {
    case 'dnevno':
      return f.times === 1 ? 'Vsak dan' : `${f.times}× dnevno`;
    case 'vsakihNDni':
      return f.n === 2 ? 'Vsak drugi dan' : `Vsakih ${f.n} dni`;
    case 'tedensko':
      return f.times === 1 ? 'Enkrat tedensko' : `${f.times}× tedensko`;
    case 'mesecno':
      return 'Enkrat mesečno';
    case 'dogovor':
      return 'Po dogovoru';
  }
}
